<tt-page *ngIf="!!page">
    <tt-page-heading *ngIf="!!page.page_heading" [ttModel]="page.page_heading"></tt-page-heading>

    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-card class="col-xs-12 p-5">
            <ng-container *ngTemplateOutlet="editForm"></ng-container>
        </tt-card>

        <tt-grid *ngIf="grid && page.quantity_from_suboperations === '1'" class="col-xs-12 p-5" [ttOptions]="grid"></tt-grid>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="work_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5">
                        <ng-container *ngTemplateOutlet="editForm"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <tt-grid *ngIf="grid && page.quantity_from_suboperations === '1'" class="col-xs-12 p-5" [ttOptions]="grid"></tt-grid>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </ng-container>
</tt-page>

<ng-template #editForm>
    <ng-container *ngIf="!!page">
        <tt-input ttLabel="businessco_companyname" [ttModel]="page.businessco_companyname" ttReadonly></tt-input>

        <tt-select ttLabel="factory_name" [ttModel]="page.factory_id" (ttModelChange)="onFactoryChanged($event)" [ttData]="selectListFactories" ttDataId="factory_id" ttDataName="factory_name">
            <tt-form-field-button buttons ttIcon="fas fa-bars" ttGoto="factories"></tt-form-field-button>
            <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttGoto="factorymenu" [ttGotoParms]="{ factory_id: page.factory_id }"></tt-form-field-button>
        </tt-select>

        <tt-select ttLabel="operation" [ttModel]="page.operation_id" (ttModelChange)="onOperationChanged($event)" [ttData]="selectListOperations" ttDataId="item_id" ttDataName="item_name">
            <tt-form-field-button buttons ttIcon="fas fa-bars" ttGoto="operations"></tt-form-field-button>
            <tt-form-field-button *ngIf="page.operation_id > ''" buttons ttIcon="fas fa-chevron-right" ttGoto="operationmenu" [ttGotoParms]="{ operation_id: page.operation_id }"></tt-form-field-button>
        </tt-select>

        <ng-container *ngIf="page.show_workgrp_keyno === '1'">
            <tt-select ttLabel="workgrp_name" [ttModel]="page.workgrp_keyno" (ttModelChange)="onWorkGroupChanged($event)" [ttData]="selectListWorkGroups" ttDataId="workgrp_keyno" ttDataName="workgrp_name" [ttShowClearButton]="page.workgrp_keyno !== '0'" ttClearValue="0">
                <tt-form-field-button buttons ttIcon="fas fa-bars" ttGoto="workgrps"></tt-form-field-button>
                <tt-form-field-button *ngIf="page.workgrp_keyno !== '0'" buttons ttIcon="fas fa-chevron-right" ttGoto="workgrpmenu" [ttGotoParms]="{ workgrp_keyno: page.workgrp_keyno }"></tt-form-field-button>
            </tt-select>
        </ng-container>

        <tt-select ttLabel="equipment" [(ttModel)]="page.equipment_id" [ttData]="selectListEquipments" ttDataId="item_id" ttDataName="item_name" [ttShowClearButton]="!!page.equipment_id" ttClearValue="">
            <tt-form-field-button buttons ttIcon="fas fa-bars" ttGoto="equipments"></tt-form-field-button>
            <tt-form-field-button *ngIf="!!page.equipment_id" buttons ttIcon="fas fa-chevron-right" ttGoto="equipmentedit" [ttGotoParms]="{ equipment_id: page.equipment_id }"></tt-form-field-button>
        </tt-select>

        <tt-checkbox *ngIf="page.use_suboperations === '1'" ttLabel="quantity_from_suboperations" [(ttModel)]="page.quantity_from_suboperations"></tt-checkbox>
        <tt-input-number ttLabel="quantity" [(ttModel)]="page.quantity" ttTextAlign="right" ttFormatNumber ttDecimals="4" [ttReadonly]="page.quantity_from_suboperations === '1'"></tt-input-number>

        <tt-select ttLabel="unit" [(ttModel)]="page.unit_no" [ttData]="selectListUnits" ttDataId="unit_no" ttDataName="unit_name">
            <tt-form-field-button buttons ttIcon="fas fa-bars" ttGoto="units"></tt-form-field-button>
            <tt-form-field-button *ngIf="page.unit_no > '0'" buttons ttIcon="fas fa-chevron-right" ttGoto="unit" [ttGotoParms]="{ unit_no: page.unit_no }"></tt-form-field-button>
        </tt-select>

        <tt-textarea ttLabel="methoddescription" [(ttModel)]="page.methoddescription"></tt-textarea>
        <tt-input-number ttLabel="operation_order" [(ttModel)]="page.operation_order" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        <tt-select ttLabel="link_linktype" [(ttModel)]="page.link_linktype" [ttData]="selectListLinkTypes" ttDataId="link_linktype" ttDataName="link_linktype_name"></tt-select>
        <tt-input-number ttLabel="link_delay_hours" [(ttModel)]="page.link_delay_hours" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
        <tt-input ttLabel="adjustment_unit_name" [ttModel]="page.adjustment_unit_name" ttReadonly></tt-input>
        <tt-input-number ttLabel="adjustment_pre" [(ttModel)]="page.adjustment_pre" ttTextAlign="right" ttFormatNumber ttDecimals="4"></tt-input-number>
        <tt-input-number ttLabel="adjustment_post" [(ttModel)]="page.adjustment_post" ttTextAlign="right" ttFormatNumber ttDecimals="4"></tt-input-number>
        <tt-button-save ttText="work_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button *ngIf="isExistingWork" ttText="work_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
        <tt-button-settings *ngIf="page.show_setting === '1'"></tt-button-settings>
    </ng-container>
</ng-template>
